<template>
  <div class="big">
    <div class="page_title">诊疗banner设置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container diagnosis-banner">
        <div class="header">
          <el-button
            type="primary"
            size="small"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1655') : false
            "
            @click="addOrEditBanner(-1, '')"
            >添加</el-button
          >
          <div class="instruct">说明:多屏时会在用户端进行轮播</div>
        </div>
        <div class="content">
          <el-table
            v-loading="tableLoading"
            :data="bannerTabelData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="category_name"
              label="banner分类"
              width="110"
              fixed="left"
            >
              <template slot-scope="scope">
                {{ scope.row.category_name }}
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  style="font-size: 20px"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1656')
                      : false
                  "
                  @click="
                    addOrEditBanner(scope.row.home_id, scope.row.category_name)
                  "
                ></el-button>
              </template>
            </el-table-column>

            <el-table-column
              class-name="style-and-content"
              prop="banner"
              label="样式及内容"
              width="1000px"
            >
              <template slot-scope="scope">
                <div class="main-box">
                  <div
                    class="content"
                    v-for="(item, index) in scope.row.banner"
                    :key="index"
                  >
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="item.image_str"
                      :preview-src-list="[item.image_str]"
                    >
                    </el-image>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.desc"
                      placement="top"
                    >
                      <div class="remark">{{ item.desc }}</div>
                    </el-tooltip>
                    <div class="btn-box">
                      <el-button
                        type="text"
                        size="medium"
                        :disabled="
                          module_id_array[0]
                            ? !module_id_array.includes('1178')
                            : false
                        "
                        @click="changeStyleSort(item, index, scope.$index, 1)"
                        >左移</el-button
                      >
                      <el-button
                        type="text"
                        size="medium"
                        :disabled="
                          module_id_array[0]
                            ? !module_id_array.includes('1178')
                            : false
                        "
                        @click="changeStyleSort(item, index, scope.$index, 2)"
                        >右移</el-button
                      >
                      <el-button
                        type="text"
                        size="medium"
                        :disabled="
                          module_id_array[0]
                            ? !module_id_array.includes('1176')
                            : false
                        "
                        @click="editStyle(item, index, scope.$index)"
                        >修改</el-button
                      >
                      <el-button
                        v-show="scope.row.status != 1"
                        type="text"
                        size="medium"
                        :disabled="
                          module_id_array[0]
                            ? !module_id_array.includes('1177')
                            : false
                        "
                        @click="delStyle(item, index, scope.$index)"
                        >删除</el-button
                      >
                    </div>
                  </div>
                  <div
                    v-show="scope.row.banner.length <= 5"
                    class="upload-icon"
                    :style="!scope.row.banner.length ? 'margin-left:51px' : ''"
                    @click="openStyleDia(scope.$index, scope.row)"
                  >
                    <i class="el-icon-plus" />
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              class-name="visibility"
              prop="visibility"
              label="可见性"
              width="110"
              fixed="right"
            >
              <template slot-scope="scope">
                <div class="visibility-box">
                  {{ scope.row.show_object | visibilityText }}
                  <el-button
                    type="text"
                    icon="el-icon-edit"
                    style="font-size: 20px"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1172')
                        : false
                    "
                    @click="openVisibility(scope.row)"
                  ></el-button>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              align="center"
              fixed="right"
              width="180"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1174')
                      : false
                  "
                  @click="changeSort(scope.row, scope.$index, 1)"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1174')
                      : false
                  "
                  @click="changeSort(scope.row, scope.$index, 2)"
                  >下移</el-button
                >
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1171')
                      : false
                  "
                  @click="changeStatus(scope.row)"
                  >{{ scope.row.status | statusText }}</el-button
                >
                <el-button
                  v-if="scope.row.status != 1"
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1170')
                      : false
                  "
                  @click="delBanner(scope.row.home_id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 样式及内容 -->
    <el-dialog
      title="请选择"
      :visible.sync="styleAndContentVisible"
      width="700px"
      :close-on-click-modal="false"
      custom-class="cus-styleAndContentVisible"
    >
      <div style="text-align: left; padding: 20px">
        <el-form
          :model="diaStyleAndContentForm"
          :rules="rules"
          ref="diaStyleAndContentRef"
          label-width="160px"
          class="styleAndContentVisible-ruleForm"
        >
          <div class="cases-box">
            <el-form-item label="备注" prop="desc">
              <el-input
                v-model="diaStyleAndContentForm.desc"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="主图" prop="image" class="main-img">
              <UploadImg
                :f_thumb="diaStyleAndContentForm.image"
                :f_thumb_str="diaStyleAndContentForm.image_str"
                @emitImg="emitMainImg"
              ></UploadImg>
              <div class="prompt">建议上传538*240</div>
            </el-form-item>

            <el-form-item label="类型" prop="min_type">
              <el-select v-model="diaStyleAndContentForm.min_type" size="small">
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              v-if="diaStyleAndContentForm.min_type"
              label="APP跳转链接/路由"
              prop="app_link_url"
            >
              <el-input
                v-model="diaStyleAndContentForm.app_link_url"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>

            <el-form-item
              v-if="diaStyleAndContentForm.min_type"
              label="小程序跳转链接/路由"
              prop="applet_link_url"
            >
              <el-input
                v-model="diaStyleAndContentForm.applet_link_url"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>

            <el-form-item
              v-if="diaStyleAndContentForm.min_type"
              label="跳转平台"
              prop="platform_applet"
            >
              <el-radio-group v-model="diaStyleAndContentForm.platform_applet">
                <el-radio :label="1">诊疗</el-radio>
                <el-radio :label="2">商城</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="styleAndContentVisible = false" size="medium" plain
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="medium"
          @click="styleAndContentConfirm('diaStyleAndContentRef')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 可见性 -->
    <el-dialog
      title="请选择"
      :visible.sync="visibilityVisible"
      width="600px"
      :close-on-click-modal="false"
      custom-class="cus-visibilityVisible"
    >
      <div style="text-align: left; padding: 20px">
        <el-form
          :model="diaVisibilityVisibleForm"
          :rules="rules"
          ref="diaVisibilityVisibleRef"
          label-width="100px"
          class="visibilityVisible-ruleForm"
        >
          <div class="cases-box">
            <el-form-item label="可见性" prop="show_object">
              <el-radio-group v-model="diaVisibilityVisibleForm.show_object">
                <el-radio :label="0">全部用户</el-radio>
                <el-radio :label="1">指定用户</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="diaVisibilityVisibleForm.show_object == 1"
              class="specify-user"
              label=""
              prop="show_object_phone"
            >
              <el-input
                v-model="diaVisibilityVisibleForm.show_object_phone"
                type="textarea"
                :rows="6"
                placeholder="请填写或粘贴指定用户的手机号,用英文逗号隔开"
                onkeyup="this.value=this.value.replace(/[ ]/g,'')"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibilityVisible = false" size="medium" plain
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="medium"
          @click="visibilityConfirm('diaVisibilityVisibleRef')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- banner名称 -->
    <el-dialog
      :title="home_id == -1 ? '添加' : '编辑'"
      :visible.sync="bannerVisible"
      width="400px"
      center
      :close-on-click-modal="false"
      custom-class="cus-visibilityVisible"
    >
      <div style="text-align: left; padding: 20px">
        <el-input
          placeholder="请输入banner分类"
          v-model="category_name"
          maxlength="5"
          clearable
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bannerVisible = false" size="medium" plain
          >取 消</el-button
        >
        <el-button type="primary" size="medium" @click="confirmCategoryNameBtn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import _ from "lodash";
import system from "@/api/system.js";
import UploadImg from "@/components/uploadImg/index";
export default {
  components: {
    UploadImg,
  },
  data() {
    const validateMainImg = (rule, value, callback) => {
      if (value === "" || !value) {
        callback(new Error("请上传图片"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        desc: [
          { required: true, message: "请输入备注", trigger: "blur" },
          { max: 50, message: "最大50个个字符", trigger: "blur" },
        ],
        image: [
          { required: true, validator: validateMainImg, trigger: "blur" },
        ],
        min_type: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
        app_link_url: [
          { required: true, message: "请输入链接/路由", trigger: "blur" },
        ],
        applet_link_url: [
          { required: true, message: "请输入链接/路由", trigger: "blur" },
        ],
        show_object: [{ required: true, message: "请选择", trigger: "change" }],
        show_object_phone: [
          { required: true, message: "请填写", trigger: "blur" },
        ],
        platform_applet: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      tableLoading: false,
      bannerTabelData: [],
      styleAndContentVisible: false,
      isStyleEdit: false,
      diaStyleAndContentForm: {
        desc: "",
        image: "",
        image_str: "",
        min_type: "",
        app_link_url: "",
        applet_link_url: "",
        platform_applet: 1,
      },
      typeOptions: [
        {
          label: "原生路由",
          value: 1,
        },
        {
          label: "跳转链接",
          value: 2,
        },
        {
          label: "小程序链接",
          value: 3,
        },
        {
          label: "无操作",
          value: 0,
        },
      ],
      tableIndex: 0,
      visibilityVisible: false,
      diaVisibilityVisibleForm: {
        home_id: "",
        show_object: 0,
        show_object_phone: "",
      },
      bannerVisible: false,
      home_id: -1,
      category_name: "",
    };
  },
  filters: {
    visibilityText(val) {
      switch (val) {
        case 0:
          return "全部用户";
        case 1:
          return "指定用户";
      }
    },
    statusText(val) {
      switch (val) {
        case 0:
          return "启用";
        case 1:
          return "禁用";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const loading = this.$loading();
      system
        .homeList()
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.bannerTabelData = data.data;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    addOrEditBanner(home_id, name) {
      if (this.bannerTabelData.length === 8 && home_id == -1) {
        this.$message.warning("最多可添加8行");
        return;
      }
      //
      this.home_id = home_id; // -1添加 其他:编辑
      this.category_name = name;
      this.bannerVisible = true;
    },
    confirmCategoryNameBtn() {
      if (this.category_name == "") {
        this.$message.error("请输入内容");
        return;
      }
      let params = {
        category_name: this.category_name,
      };

      let interfaceName = "addHomeCategoryName";
      if (this.home_id != -1) {
        params.home_id = this.home_id;
        interfaceName = "updateHomeCategoryName";
      } else {
        interfaceName = "addHomeCategoryName";
      }

      let loading = this.$loading();
      system[interfaceName](params)
        .then((res) => {
          let { code } = res;
          if (code === 0) {
            this.bannerVisible = false;
            this.getList();
            loading.close();
          }
        })
        .catch(() => loading.close());
    },
    /********* 样式及内容操作 ********/
    changeStyleSort(item, styleIndex, index, type) {
      let { banner_id, sort } = item;
      const loading = this.$loading();
      let params = {
        banner_id1: "",
        sort1: "",
        banner_id2: "",
        sort2: "",
      };
      let banner = this.bannerTabelData[index].banner;
      let changeData = {};
      switch (type) {
        case 1:
          changeData = !styleIndex
            ? banner[banner.length - 1]
            : banner[styleIndex - 1];
          params = {
            banner_id1: banner_id,
            sort1: changeData.sort,
            banner_id2: changeData.banner_id,
            sort2: sort,
          };
          break;

        case 2:
          changeData =
            styleIndex === banner.length - 1
              ? banner[0]
              : banner[styleIndex + 1];
          params = {
            banner_id1: changeData.banner_id,
            sort1: sort,
            banner_id2: banner_id,
            sort2: changeData.sort,
          };
          break;
      }
      system
        .setHomeBannerSort(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.$message.success(`${type == 1 ? "左移" : "右移"}成功`);
            this.getList();
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    editStyle(item, styleIndex, index) {
      console.log(item);
      this.tableIndex = index;
      this.diaStyleAndContentForm = Object.assign({}, item);
      this.styleAndContentVisible = true;
      this.isStyleEdit = true;
    },
    delStyle(item, styleIndex, index) {
      this.tableIndex = index;
      let params = {
        banner_id: item.banner_id,
      };
      this.$confirm("确认删除该样式？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const loading = this.$loading();
          system
            .deleteHomeBanner(params)
            .then((res) => {
              let { code, data } = res;
              if (code === 0) {
                this.$message.success("删除成功");
                this.getList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    /********* 样式及内容操作--end *****/
    changeSort(row, index, type) {
      const loading = this.$loading();
      let { home_id, sort } = row;
      let params = {
        home_id1: "",
        sort1: "",
        home_id2: "",
        sort2: "",
      };
      let changeData = {};
      let copyData = JSON.parse(JSON.stringify(this.bannerTabelData));
      switch (type) {
        case 1:
          changeData = !index
            ? copyData[copyData.length - 1]
            : copyData[index - 1];
          params = {
            home_id1: home_id,
            sort1: changeData.sort,
            home_id2: changeData.home_id,
            sort2: sort,
          };
          break;

        case 2:
          changeData =
            index === copyData.length - 1 ? copyData[0] : copyData[index + 1];
          params = {
            home_id1: changeData.home_id,
            sort1: sort,
            home_id2: home_id,
            sort2: changeData.sort,
          };
          break;
      }

      system
        .setHomeSort(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.$message.success(`${type == 1 ? "上移" : "下移"}成功`);
            this.getList();
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    changeStatus(row) {
      let { home_id, status } = row;
      const loading = this.$loading();
      let params = {
        home_id,
        status: status == 1 ? 0 : 1,
      };
      system
        .updateHomeStatus(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.$message.success(`${status == 1 ? "禁用" : "启用"}成功`);
            this.getList();
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    delBanner(home_id) {
      this.$confirm("确认删除该banner？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const loading = this.$loading();
          system
            .deleteHome({ home_id })
            .then((res) => {
              let { code, data } = res;
              if (code === 0) {
                this.$message.success("删除成功");
                this.getList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    openStyleDia(index, row) {
      for (let key in this.diaStyleAndContentForm) {
        if (key == "platform_applet") {
          this.diaStyleAndContentForm[key] = 1;
        } else {
          this.diaStyleAndContentForm[key] = "";
        }
      }
      this.$nextTick(() => {
        this.$refs["diaStyleAndContentRef"]
          ? this.$refs["diaStyleAndContentRef"].clearValidate()
          : "";
      });
      this.diaStyleAndContentForm.home_id = row.home_id;
      this.tableIndex = index;
      this.isStyleEdit = false;
      this.styleAndContentVisible = true;
    },
    emitMainImg(data) {
      console.log(data);
      this.diaStyleAndContentForm.image = data.pic;
      this.diaStyleAndContentForm.image_str = data.path;
    },
    styleAndContentConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.diaStyleAndContentForm);
          let interfaceName = "addHomeBanner";
          if (this.isStyleEdit) {
            interfaceName = "editHomeBanner";
          } else {
            params.sort = !this.bannerTabelData[this.tableIndex].banner.length
              ? 1
              : this.bannerTabelData[this.tableIndex].banner.length + 1;
            interfaceName = "addHomeBanner";
          }
          const loading = this.$loading();
          system[interfaceName](params)
            .then((res) => {
              let { code, data } = res;
              if (code === 0) {
                this.$message.success(
                  `${this.isStyleEdit ? "编辑" : "添加"}成功`
                );
                this.getList();
              }
              loading.close();
              this.styleAndContentVisible = false;
            })
            .catch((err) => {
              loading.close();
              this.styleAndContentVisible = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 可见性操作
    openVisibility(row) {
      let { home_id, show_object, show_object_phone } = row;
      this.diaVisibilityVisibleForm = {
        home_id,
        show_object,
        show_object_phone,
      };
      this.visibilityVisible = true;
    },
    visibilityConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          let params = Object.assign({}, this.diaVisibilityVisibleForm);
          system
            .setHome(params)
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success("设置成功");
                this.getList();
              }
              loading.close();
              this.visibilityVisible = false;
            })
            .catch((err) => {
              loading.close();
              this.visibilityVisible = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.prompt {
  font-size: 12px;
  text-align: left;
  color: red;
  padding-left: 10px;
}
.cus-styleAndContentVisible {
  .styleAndContentVisible-ruleForm {
    .cases-box {
      height: 100%;
      .main-img {
        height: 126px;
        ::v-deep .el-form-item__content {
          height: 100%;
        }
      }
    }
  }
}
.cus-visibilityVisible {
  .visibilityVisible-ruleForm {
    .cases-box {
      ::v-deep .el-form-item__content {
        height: auto;
      }
    }
  }
}
.diagnosis-banner {
  .header {
    text-align: left;
    .instruct {
      padding-top: 10px;
    }
  }
  .content {
    border: solid 1px #c9cbd6;
    .style-and-content {
      .main-box {
        width: 100%;
        display: flex;
        .content {
          border: none;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 10px;
          cursor: pointer;
          .remark {
            width: 200px;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-top: 10px;
          }
        }
        .upload-icon {
          width: 100px;
          height: 100px;
          border: 1px dashed #666;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          i {
            font-size: 40px;
            color: #666;
          }
        }
      }
    }
    .visibility {
      .visibility-box {
        display: flex;
        align-items: center;
        cursor: pointer;
        i {
          font-size: 20px;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
